import { ILiquidityPool } from "./types"

export const poolSearch = (pool: ILiquidityPool, search: string | null) => {
  if (!search) return true

  const searchLower = search.toLowerCase()

  const found =
    pool.address.equalsString(searchLower) ||
    (pool.displayName ?? "").toLowerCase().includes(searchLower) ||
    (pool.displayType ?? "").toLowerCase().includes(searchLower)

  if (found) {
    return true
  }

  // tokens (variable length)
  const tokensFound = pool.tokens.map((token) => {
    return token.symbol.toLowerCase().includes(searchLower) || token.address.includes(searchLower)
  })
  if (tokensFound.includes(true)) {
    return true
  }

  // now we search in tags
  if (Array.isArray(pool.tags)) {
    const found = pool.tags.some((tag: string) => tag.toLowerCase().includes(searchLower))
    if (found) {
      return true
    }
  }

  return false
}
